import React from 'react';

const ApproveIcon = () => (
  <svg
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4111 2.54597L7.41113 14.546C7.30661 14.6509 7.18242 14.7341 7.04568 14.7909C6.90893 14.8476 6.76232 14.8769 6.61426 14.8769C6.46619 14.8769 6.31958 14.8476 6.18284 14.7909C6.04609 14.7341 5.9219 14.6509 5.81738 14.546L0.567381 9.29598C0.462734 9.19133 0.379723 9.06709 0.323089 8.93037C0.266454 8.79364 0.237305 8.64709 0.237305 8.4991C0.237305 8.35111 0.266454 8.20456 0.323089 8.06783C0.379723 7.93111 0.462734 7.80687 0.567381 7.70223C0.672028 7.59758 0.796262 7.51457 0.93299 7.45793C1.06972 7.4013 1.21626 7.37215 1.36426 7.37215C1.51225 7.37215 1.65879 7.4013 1.79552 7.45793C1.93225 7.51457 2.05648 7.59758 2.16113 7.70223L6.61519 12.1563L17.8193 0.9541C18.0306 0.742755 18.3172 0.624023 18.6161 0.624023C18.915 0.624023 19.2017 0.742755 19.413 0.9541C19.6243 1.16544 19.7431 1.45209 19.7431 1.75098C19.7431 2.04986 19.6243 2.33651 19.413 2.54785L19.4111 2.54597Z"
      fill="#6D87FF"
    />
  </svg>
);

export default ApproveIcon;
